import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';


const AnonPage = ({ children }) => <div className='anon-page'>
  {children}
</div>;

export default AnonPage;

const ContentWithScroll = ({ children }) => <Scrollbars
  className='page-content scroll'
  id='page-content'
>
  {children}
</Scrollbars>;

const ContentNoScroll = ({ children }) => <div
  className='page-content'
  id='page-content'
>
  {children}
</div>;


export const Content = ({ scroll, ...props }) => scroll ?
  <ContentWithScroll {...props} />
  :
  <ContentNoScroll {...props} />;